// Purchase-stage Google Ads conversion. gtag.js and the `config` calls for
// AW-11198534691 and G-2GMLB0RV3B come from the site-wide bundle mounted on
// `__root.tsx`; repeating `config` here double-fired the GA4 page_view. The
// `dataLayer` shim stays so this script is order-independent, and the only
// call it makes is the conversion event scoped to the purchase action ID.
//
// `value` was previously omitted, which meant Google Ads counted each
// conversion at whatever default value was set in the Google Ads UI —
// the same drift pattern R2 fixed for TikTok / Meta / Reddit. Now
// parameterized on the loader-resolved `amountUsd`, sourced from the
// real Stripe `unit_amount` for the user's primary subscription.
//
// `transaction_id` stays empty: Google Ads requires it for
// deduplication only when you import offline conversions; for the
// online click → purchase flow we don't need it. (When CAPI / R5
// lands, generate a stable id matching the server-side event so any
// future offline import can reconcile.)
//
// `currency` is threaded down from the route loader alongside the
// amount — Google Ads converts to the account currency using it, so a
// hardcoded USD would misprice every non-USD conversion.
export function googleTagCreateYourAccountScript(
  value: number,
  currency: string,
): string {
  return `
/* eslint-disable -- inline pixel script, vendor-shaped js */
window.dataLayer = window.dataLayer || [];
function gtag() { dataLayer.push(arguments); }
gtag('event', 'conversion', {
  send_to: 'AW-11198534691/oPPyCN7S0aoYEKOo8Nsp',
  value: ${value},
  currency: '${currency}',
  transaction_id: '',
});
`;
}
